import { postAxios } from './axiosActions';
import { GET_LEAVE_DATA, EMPLOYEE_LEAVE_COUNT, GET_EMPLOYEE_DATA, EDIT_LEAVE_DATA, GET_EMPLOYEE_ID,GET_LEAVE_REPORT } from './actionTypes';



export const getLeaveData = (params) => {

    if (params == null) {
        params = { callTime: new Date() };
    }
    const url = 'Employee/GetEmployeeLeaves';
    const request = postAxios(url, { params: params });
    return {
        type: GET_LEAVE_DATA,
        payload: request
    }
};
export const getLeaveDataById = (params) => {
    if (params == null) {
        params = { callTime: new Date() };
    }
    const url = 'Employee/GetEmployeeLeavesById';
    const request = postAxios(url, { params: params });
    return {
        type: GET_LEAVE_DATA,
        payload: request
    }
};
const dateFormat = (date) => {

    var date = new Date(date),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
}

const emptyGuid = '00000000-0000-0000-0000-000000000000';

const buildInsertLeavePayload = (params) => {
    const leaveCount = params.leaveCount === 'firstHalf' || params.leaveCount === 'SecondHalf'
        ? 0.5
        : parseFloat(params.leaveCount) || 1;
    const isSecondHalf = params.leaveCount === 'SecondHalf'
        ? true
        : (params.leaveCount === 'firstHalf' ? false : (params.IsSecondHalf === true || params.IsSecondHalf === 1));

    const leaveFromDate = params.leaveFromDate ? dateFormat(params.leaveFromDate) : dateFormat(new Date());
    const leaveToDate = params.leaveToDate ? dateFormat(params.leaveToDate) : leaveFromDate;

    return {
        LeaveId: (params.LeaveId || params.leaveId || '') ? (params.LeaveId || params.leaveId) : emptyGuid,
        employeeId: (params.employeeId || params.EmployeeId || '') ? (params.employeeId || params.EmployeeId) : emptyGuid,
        leaveFromDate: leaveFromDate,
        leaveToDate: leaveToDate,
        leaveType: params.leaveType || 'CL',
        leaveCount: leaveCount,
        remarks: params.remarks || '',
        IsApproved: params.IsApproved === true || params.IsApproved === 1,
        IsSecondHalf: isSecondHalf
    };
};

export const insertLeave = async (params) => {
    const payload = buildInsertLeavePayload(params);
    const url = 'Employee/InsertEmployeeLeave';
    const request = await postAxios(url, { params: payload }).then(function (response) {
        // if (response.data = "ok") {
        //     alert("Leave Applied Successfully")
        // }
    })
        .catch(function (response) {
            console.log(response);
        });
    return request
};
export const editLeave = async (params) => {
    if (params == null) {
        params = { callTime: new Date() };
    }
    params.leavedate = dateFormat(params.leavedate)
    const url = 'Employee/editEmployeeLeaves';
    const request = await postAxios(url, { params: params }).then((response) => {

        return response.data;
    })
    return request;
}
export const deleteLeave = async (params) => {

    if (params == null) {
        params = { callTime: new Date() };
    }
    const url = 'Employee/deleteEmployeeLeave';
    const request = await postAxios(url, { params: params });
    return {
        type: GET_LEAVE_DATA,
        payload: request
    }
}
export const getEmployeeData = async (params) => {
    if (params == null) {
        params = { callTime: new Date() };
    }
    const url = 'Employee/GetEmployeeData';
    const request = await postAxios(url, { params: params });
    return {
        type: GET_EMPLOYEE_DATA,
        payload: request
    }
}
export const employeeLeaveCount = async (params) => {

    if (params == null) {
        params = { callTime: new Date() };
    }
    const url = 'Employee/EmployeeLeaveCount';
    const request = await postAxios(url, { params: params });
    return {
        type: EMPLOYEE_LEAVE_COUNT,
        payload: request
    }
}
export const approveEmployeeLeave = async (params) => {

    if (params == null) {
        params = { callTime: new Date() };
    }
    const url = 'Employee/ApproveEmployeeLeave';
    const request = await postAxios(url, { params: params });
    return request;
}
export const editLeaveDataMap = (request) => {
    return {
        type: EDIT_LEAVE_DATA,
        payload: request
    }
}
export const getUpdateEmpId = (request) => {

    return {
        type: GET_EMPLOYEE_ID,
        payload: request
    }
}
export const getUpdateEmpYear = (request) => {
    return {
        type: 'GET_EMPLOYEE_YEAR',
        payload: request
    }
}
export const getLeaveReport = (params) => {
    if (params == null) {
        params = { callTime: new Date() };
    }
    const url = 'Employee/GetLeaveReport'
    const request = postAxios(url, { params: params })
    return {
        type: GET_LEAVE_REPORT,
        payload: request
    }
}

